export const Special = Object.freeze({
} as const);
